import { createReducer, on } from '@ngrx/store';

import { GroupActions } from './actions';
import { groupAdapter, groupAdapterInitialState, GroupState } from './state';

const getGroupssReducer = [
  on(GroupActions.GetGroups.request, (state: GroupState) => ({
    ...state,
    isLoading: true,
  })),
  on(GroupActions.GetGroups.success, (state: GroupState, { items }) =>
    groupAdapter.setAll(items, { ...state, isLoading: false }),
  ),
];

const failureReducer = [
  on(GroupActions.failure, (state: GroupState, { errorMessage }) => ({
    ...state,
    isLoading: false,
    errorMessage,
  })),
];

export const GroupReducer = createReducer<GroupState>(
  groupAdapterInitialState,
  ...getGroupssReducer,
  ...failureReducer,
);
